import * as React from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import Text from 'design-system/Text';
import PointerCursor from 'design-system/icons/PointerCursor';
import useColors from 'hooks/useColors';
import { rem } from 'design-system/values';
import { Spacer } from 'design-system';
import AnimatingTouchArea from './AnimatingTouchArea';
const TouchHelper = ({ position, onPress }) => {
    const colors = useColors();
    if (position === 'right') {
        return (<View style={styles.containerRight} pointerEvents={onPress ? 'auto' : 'none'}>
        <View style={styles.animatingTouchAreaContainer}>
          <TouchableOpacity onPress={onPress} activeOpacity={1}>
            <View pointerEvents="none">
              <AnimatingTouchArea />
            </View>
          </TouchableOpacity>
          <View style={styles.pointerCursorContainerRight} pointerEvents="none">
            <PointerCursor position={position}/>
          </View>
        </View>
        <Spacer w={16}/>
        <Text Text-16 color={colors.text.whiteOnColor}>
          Tap
        </Text>
      </View>);
    }
    if (position === 'left') {
        return (<View style={styles.containerLeft} pointerEvents={onPress ? 'auto' : 'none'}>
        <View style={styles.animatingTouchAreaContainer}>
          <TouchableOpacity onPress={onPress} activeOpacity={1}>
            <View pointerEvents="none">
              <AnimatingTouchArea />
            </View>
          </TouchableOpacity>
          <View style={styles.pointerCursorContainerLeft} pointerEvents="none">
            <PointerCursor position={position}/>
          </View>
        </View>
        <Spacer w={16}/>
        <Text Text-16 color={colors.text.whiteOnColor}>
          Tap
        </Text>
      </View>);
    }
    return (<View style={styles.container} pointerEvents={onPress ? 'auto' : 'none'}>
      <View style={styles.animatingTouchAreaContainer}>
        <TouchableOpacity onPress={onPress} activeOpacity={1}>
          <View pointerEvents="none">
            <AnimatingTouchArea />
          </View>
        </TouchableOpacity>
        <View style={styles.pointerCursorContainer} pointerEvents="none">
          <PointerCursor position={position}/>
        </View>
      </View>
      <Text Text-16 color={colors.text.whiteOnColor}>
        Tap
      </Text>
    </View>);
};
export default React.memo(TouchHelper);
const styles = StyleSheet.create({
    container: {
        alignItems: 'flex-end',
    },
    animatingTouchAreaContainer: {
        paddingBottom: rem(4),
        paddingHorizontal: rem(4),
    },
    pointerCursorContainer: {
        right: 0,
        bottom: 0,
        position: 'absolute',
    },
    pointerCursorContainerRight: {
        top: 0,
        bottom: 0,
        right: -rem(12),
        justifyContent: 'center',
        position: 'absolute',
    },
    containerRight: {
        alignItems: 'center',
        flexDirection: 'row',
    },
    containerLeft: {
        alignItems: 'center',
        flexDirection: 'row-reverse',
    },
    pointerCursorContainerLeft: {
        top: 0,
        bottom: 0,
        left: -rem(12),
        justifyContent: 'center',
        position: 'absolute',
    },
});
